//client side redirect
$('form[data-form-search]').submit(function (e) {

    var searchTarget = $(this).attr("data-form-search-target");

    var serializedInput = $(this).find('*').not('[data-form-exclude]').serialize();

    //console.log("form submitted with serailized input:");
    //console.log(serializedInput);

    //if there is not a search target, its /, or the current page, updated query string, which can then be hooked into as an event for ajax refreshes by other components
    if (!searchTarget || searchTarget === '/' || searchTarget === window.location.href.replace(window.location.search, '')) {
        changeQueryString(serializedInput);
    }
    //otherwise, redirect to search target
    else if (searchTarget) {
        
        window.location.href = searchTarget + '?' + serializedInput;
    }
});

function changeQueryString(queryString) {
    var newUrl = window.location.href.split(/[?#]/)[0] + "?" + queryString;
    window.history.pushState({ path: newUrl }, '', newUrl);
}

//$(document).on('click', '[data-category]:not(.disabled)', function () {
//    var category = $(this).attr('data-category');

//    $(this).closest('section').find('[data-category]').removeClass('active');

//    if (!category) {
//        $(this).closest('section').find('.unified-results-section').show();
//        $(this).addClass('active');
//    }
//    else {
//        $(this).closest('section').find('[data-category=' + category + ']').addClass('active');
//        $(this).closest('section').find('.unified-results-section:not(.' + category + ')').hide();
//        $(this).closest('section').find('.' + category).show();
//    }
//});

$(document).on('click', '[data-toggle-tab-for]', function (event) {

    var target = $(this).attr('data-toggle-tab-for');

    $(target).tab('show');

    //target = $(event.target).closest('section');

    ////pre calculated offset
    //var headerOffset = parseInt(target.css("scroll-margin-top"), 10);
    //var targetOffset = target.offset().top;
    //var calculatedOffset = targetOffset - headerOffset;

    ////compensating for unknown pixel offset
    //calculatedOffset = calculatedOffset + 1;

    //// Only prevent default if animation is actually gonna happen
    //$('html, body').animate({
    //    scrollTop: calculatedOffset
    //}, 0, function () {
    //    // Callback after animation 
    //    // Must change focus!
    //    var $target = $(target);
    //    $target.focus();
    //    if ($target.is(":focus")) { // Checking if the target was focused
    //        return false;
    //    } else {
    //        $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
    //        $target.focus(); // Set focus again
    //    };
    //});
});